import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import TimelineBody from './Body';

const View = ({ data, className }) => (
  <div className={className}>
    <TimelineBody episodes={data.episodes} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
